import { Vue, Options } from 'vue-class-component';

@Options({
  name: 'DialogConfirmChangeLanguage',
  props: {
    languages: {
      type: Object,
      required: true,
    },
    selectedLanguage: {      
      type: Number,
      required: true,
    },
    isVisible: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    isVisible: function (newValue) {
      this.isDialogVisible = newValue;
    },
    selectedLanguage: function (newValue) {
      this.selectedLanguageInside = this.languages[newValue];
    },
  },
  emits: ['hide-dialog', 'confirm'],
})
export default class DialogConfirmChangeLanguage extends Vue {
  languages!: string[];
  isVisible!: boolean;
  selectedLanguage!: number;
  isDialogVisible = false;
  selectedLanguageInside : any = null;

  mounted() {
    this.selectedLanguageInside = this.languages[this.selectedLanguage];
    this.isDialogVisible = !!this.isVisible;
  }

  handleHideDialog() {
    this.isDialogVisible = false;
  }

  doHideDialog() {
    this.selectedLanguageInside = this.languages[this.selectedLanguage];
    this.$emit('hide-dialog');
  }

  selectLanguage(selectLanguage: any) {
    this.selectedLanguageInside = selectLanguage;
  }

  doConfirm() {
    this.$emit('confirm', this.selectedLanguageInside.code);
    this.handleHideDialog();
  }
}
